import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { FreshserviceConnector } from '../../connector';

export const FreshserviceService = IntegrationService.make({
  connector: FreshserviceConnector,
  name: Integration_Service_Names_Enum.Freshservice,
});
